<div class="form-buttons">
  <ng-content></ng-content>
</div>
